// extracted by mini-css-extract-plugin
var _1 = "iX4IIa2x_hiPCCWc0UC6";
export { _1 as "text" }
